import React, { useEffect, useState, useCallback } from "react";
import DataTable from "../Components/Common/DataTable";
import PremiumFilterBar from "../Components/Common/PremiumFilterBar";
import DeleteButton from "../Components/Common/DeleteButton";
import ViewButton from "./Common/ViewButton";
import LoaderCon from "../../Common/loader/containers/loader_cont";
import Snackbar1 from "../../Common/snackbar/components/snackbar";
import { downloadExcel } from "../../utils/downloadExcel";

const statusColors = {
  Requested: "#6366f1",       // Indigo
  Pending: "#f59e0b",         // Amber
  "In Progress": "#3b82f6",   // Blue
  Resolved: "#22c55e",        // Green
  Closed: "#6b7280",          // Gray
};

export default function Service({
  login,
  client,
  viewAllVehicleEnq,
  deleteVehicleEnq,
  updateVehicleEnqStatus,
  close_snack_bar,
  snackbar
}) {
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(20);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [editingStatusId, setEditingStatusId] = useState(null);

  const fetchData = useCallback(() => {
    viewAllVehicleEnq(
      login.token,
      login.user_id,
      searchInput,
      page,
      rowsPerPage,
      startDate,
      endDate,
      selectedStatus
    );
  }, [login, searchInput, page, rowsPerPage, startDate, endDate, selectedStatus, viewAllVehicleEnq]);

  // Debounced search
  useEffect(() => {
    const timer = setTimeout(fetchData, 300);
    return () => clearTimeout(timer);
  }, [searchInput, fetchData]);

  // Reload on page/rows/date/status change
  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, startDate, endDate, selectedStatus, fetchData]);

  const vehicalenq = client?.all_vehicleEnq || [];
  // const vehicalenqCount = client?.all_vehicleEnqlength || 0;
  const vehicalenqCount = vehicalenq.length;
  const pageLength = client?.vehicalenq_length || 0;

  const handleDownloadExcel = () => {
    downloadExcel(
      "vehicleEnq/export-vehicle-enq",
      "VehicleEnquiryReport",
      "POST",
      {
        search: searchInput,
        startDate,
        endDate,
        status: selectedStatus,
        user_id: login.user_id,
      },
      login.token
    );
  };

  const columns = [
    {
      header: "Name",
      key: "name",
      render: (row) => `${row.firstName || ""} ${row.lastName || ""}`.trim(),
    },
    { header: "Mobile", key: "mobile" },
    { header: "Email", key: "email" },
    { header: "Car Model", key: "carType" },
    { header: "Dealer", key: "dealer" },
    {
      header: "Created Date",
      key: "createdAt",
      render: (row) => {
        const date = new Date(row.createdAt);
        const formattedDate = date.toLocaleDateString();
        const formattedTime = date.toLocaleTimeString();

        return (
          <span style={{ display: "flex", flexDirection: "column", lineHeight: "16px" }}>
            <span>{formattedDate}</span>
            <span style={{ fontSize: "12px", color: "#555" }}>{formattedTime}</span>
          </span>
        );
      },
    },
    {
      header: "Status",
      key: "status",
      render: (row) => {
        const isEditing = editingStatusId === row._id;
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {isEditing ? (
              <select
                className="premium-select"
                style={{ padding: "4px 8px", fontSize: "12px" }}
                value={row.status}
                autoFocus
                onBlur={() => setEditingStatusId(null)}
                onChange={(e) => {
                  updateVehicleEnqStatus(
                    login.token,
                    login.user_id,
                    row._id,
                    e.target.value,
                    page,
                    rowsPerPage
                  );
                  setEditingStatusId(null);
                }}
              >
                {Object.keys(statusColors).map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}
              </select>
            ) : (
              <span
                onClick={() => setEditingStatusId(row._id)}
                style={{
                  backgroundColor: statusColors[row.status] || "#eee",
                  color: "white",
                  padding: "4px 12px",
                  borderRadius: "20px",
                  fontSize: "12px",
                  fontWeight: "600",
                  cursor: "pointer",
                  display: "inline-block",
                  transition: "opacity 0.2s"
                }}
                onMouseOver={(e) => (e.currentTarget.style.opacity = "0.8")}
                onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}
              >
                {row.status}
              </span>
            )}
          </div>
        );
      },
    },
    {
      header: "Actions",
      key: "actions",
      render: (row) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <ViewButton
            title="Vehicle Enquiry Details"
            columns={[
              { label: "First Name", key: "firstName" },
              { label: "Last Name", key: "lastName" },
              { label: "Mobile", key: "mobile" },
              { label: "Email", key: "email" },
              { label: "Car Model", key: "carType" },
              { label: "Dealer", key: "dealer" },
              { label: "Pincode", key: "pincode" },
              {
                label: "Created Date",
                key: "createdAt",
                render: (row) => {
                  const d = new Date(row.createdAt);
                  return (
                    <>
                      {d.toLocaleDateString()} <br />
                      <span style={{ fontSize: "12px", color: "#555" }}>
                        {d.toLocaleTimeString()}
                      </span>
                    </>
                  );
                },
              },
              {
                label: "Last Updated",
                key: "updatedAt",
                render: (row) => {
                  const d = new Date(row.updatedAt);
                  return (
                    <>
                      {d.toLocaleDateString()} <br />
                      <span style={{ fontSize: "12px", color: "#555" }}>
                        {d.toLocaleTimeString()}
                      </span>
                    </>
                  );
                },
              },
              { label: "Status", key: "status" },
            ]}
            data={row}
          />
          <DeleteButton
            item={row}
            viewName="Vehicle Enquiry"
            onDelete={(item) => deleteVehicleEnq(login.token, login.user_id, item._id, page, rowsPerPage)}
          />
        </div>
      ),
    },
  ];

  return (
    <div>
      <PremiumFilterBar
        title={`Vehicle Enquiries (${vehicalenqCount})`}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        onDateChange={({ start, end }) => {
          setStartDate(start);
          setEndDate(end);
        }}
        onExport={handleDownloadExcel}
      />

      <DataTable
        columns={columns}
        data={vehicalenq}
        page={page}
        totalPage={pageLength}
        onPageChange={(p) => setPage(p)}
        rowsPerPage={rowsPerPage}
      />

      <LoaderCon />
      <Snackbar1
        open={snackbar.response_received}
        close_snack_bar={() => close_snack_bar()}
        message={snackbar.message}
      />
    </div>
  );
}

